/* Ricerca predittiva: Section Rendering API (/search/suggest?section_id=predictive-search). Senza JS il modulo invia a /search. */
(function () {
  'use strict';
  var input = document.getElementById('cerca-q');
  if (!input || !input.form) return;
  var box = document.querySelector('#cerca [data-predictive]');
  var sug = document.querySelector('#cerca [data-search-suggest]');
  if (!box) return;
  var dlg = document.getElementById('cerca');
  var live = document.querySelector('#cerca [data-predictive-live]');
  var base = (input.form.getAttribute('action') || '/search').replace(/\/$/, '') + '/suggest';
  var timer, ctrl, opts = [], cur = -1;

  var MSG = { one: 'data-msg-one', other: 'data-msg-other', none: 'data-msg-none', error: 'data-msg-error' };
  function msg(k) { return (dlg && dlg.getAttribute(MSG[k])) || ''; }
  function say(text) { if (live) live.textContent = text; }
  function setActive(i) { /* freccia: sposta aria-activedescendant sull'opzione i-esima, -1 = nessuna */
    if (opts[cur]) opts[cur].removeAttribute('aria-selected');
    cur = i;
    if (opts[cur]) {
      opts[cur].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[cur].id);
      if (opts[cur].scrollIntoView) opts[cur].scrollIntoView({ block: 'nearest' });
    } else input.removeAttribute('aria-activedescendant');
  }
  function mark() { /* ruoli listbox/option sul markup della sezione predictive-search */
    opts = [].slice.call(box.querySelectorAll('a'));
    var root = box.querySelector('[data-predictive-results]');
    if (root) root.setAttribute('role', 'listbox');
    [].forEach.call(box.querySelectorAll('ul,li,.bt-predictive__group,.bt-chips'), function (el) { el.setAttribute('role', 'presentation'); });
    opts.forEach(function (a, i) { a.id = 'cerca-opt-' + i; a.setAttribute('role', 'option'); a.setAttribute('tabindex', '-1'); });
    cur = -1;
    var n = opts.length - (box.querySelector('.bt-predictive__all') ? 1 : 0);
    say(n > 0 ? msg(n === 1 ? 'one' : 'other').replace('__N__', n) : msg('none'));
  }

  function reset() {
    if (ctrl) ctrl.abort();
    box.hidden = true;
    box.innerHTML = '';
    box.removeAttribute('aria-busy');
    if (sug) sug.hidden = false;
    opts = []; cur = -1;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    say('');
  }

  function run(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    box.setAttribute('aria-busy', 'true');
    var url = base + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6';
    fetch(url, { signal: ctrl.signal, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (input.value.trim() !== q) return;
        var res = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-predictive-results]');
        if (!res) return reset();
        box.innerHTML = res.outerHTML;
        box.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        mark();
        box.removeAttribute('aria-busy');
        if (sug) sug.hidden = true;
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        reset();
        var m = msg('error');
        if (m) { box.innerHTML = '<p class="bt-predictive__empty"></p>'; box.firstChild.textContent = m; box.hidden = false; box.removeAttribute('aria-busy'); if (sug) sug.hidden = true; say(m); }
      });
  }

  input.addEventListener('keydown', function (e) {
    if (box.hidden || !opts.length) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(cur + 1 >= opts.length ? 0 : cur + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(cur <= 0 ? opts.length - 1 : cur - 1); }
    else if (e.key === 'Enter' && opts[cur]) { e.preventDefault(); opts[cur].click(); }
  });

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) return reset();
    timer = setTimeout(function () { run(q); }, 250);
  });
})();
